import { render, staticRenderFns } from "./BtnDetalheReprovacao.vue?vue&type=template&id=669012aa"
import script from "./BtnDetalheReprovacao.vue?vue&type=script&lang=js"
export * from "./BtnDetalheReprovacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports